import { useCallback, useMemo, useState } from "react";

export function usePanelStack<T>(initial: T[] = []) {
  const [stack, setStack] = useState<T[]>(initial);

  const open = useCallback((panel: T) => {
    setStack((prev) => [...prev.filter((p) => p !== panel), panel]);
  }, []);

  const close = useCallback((panel: T) => {
    setStack((prev) => prev.filter((p) => p !== panel));
  }, []);

  const closeTop = useCallback(() => {
    setStack((prev) => prev.slice(0, -1));
  }, []);

  const reset = useCallback((next: T[] = []) => {
    setStack(next);
  }, []);

  const top = useMemo(
    () => (stack.length ? stack[stack.length - 1] : null),
    [stack]
  );

  const has = useCallback((panel: T) => stack.includes(panel), [stack]);

  return { stack, top, open, close, closeTop, reset, has };
}
